/** Interval (ms) at which the "saved X ago" relative-time text is refreshed. */
export const SAVE_TIME_UPDATE_INTERVAL_MS = 60_000;

export const ICON_SAVE = 'icon-save';

export const ICON_SAVE_STATE_OFFLINE = 'icon-offline';

export interface SaveStatusProps {
  /** Toggles the save-error popover from the persistent "Unable to save." indicator. */
  onErrorIndicatorClick: () => void;
}
